<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

    <div class="table-responsive-md">
        <table class="table table-striped text-center text-uppercase">
            <tr>
                <th class="bg-gray-200"></th>
                <th class="bg-light">Jan</th>
                <th class="bg-light">Fev</th>
                <th class="bg-light">Mar</th>
                <th class="bg-light">Abr</th>
                <th class="bg-light">Mai</th>
                <th class="bg-light">Jun</th>
                <th class="bg-light">Jul</th>
                <th class="bg-light">Ago</th>
                <th class="bg-light">Set</th>
                <th class="bg-light">Out</th>
                <th class="bg-light">Nov</th>
                <th class="bg-light">Dez</th>
            </tr>
            <tr *ngFor="let a of consulta.registros.sintetico | keyvalue; let index = i">
                <td class="fw-700 bg-light">{{ a.key }}</td>
                <td *ngFor="let m of a.value">{{m || '-'}}</td>
            </tr>
        </table>
        <div class="w-100 pt-1 bg-gray-200"></div>
        <table class="table table-striped border-top border-gray-200">
            <tr>
                <th class="bg-light">DATA</th>
                <th class="bg-light">EMPRESA</th>
                <th class="bg-light">CNPJ</th>

            </tr>
            <tr *ngFor="let a of consulta.registros.analitico; let index = i">
                <td>{{ a.data }}</td>
                <td>{{ a.associado }}</td>
                <td>{{ a.cnpj }}</td>
            </tr>
        </table>
    </div>

</app-card-consulta>